import { isEmpty, get } from 'lodash';
import Error from '@/pages/errors/ErrorPlaceholder';

const propsFunc = errorCode => (route) => {
  const { params } = route;
  if (!isEmpty(params)) {
    const errorMessage = get(params, 'errorMessage', '');
    return { errorCode, errorMessage };
  }
  return { errorCode };
};

export default [
  {
    name: 'error.404',
    path: '/error/404',
    component: Error,
    props: propsFunc(404),
    meta: {
      title: '',
    },
  },
  {
    name: 'error.500',
    path: '/error/500',
    component: Error,
    props: propsFunc(500),
    meta: {
      title: '',
    },
  },
  {
    name: 'error.400',
    path: '/error/400',
    component: Error,
    props: propsFunc(400),
    meta: {
      title: '',
    },
  },
  {
    name: 'error.403',
    path: '/error/403',
    component: Error,
    props: propsFunc(403),
    meta: {
      title: '',
    },
  },
];
